<template>
    <div style="height:100%;overflow-y:hidden">
        <a-layout id="components-layout-demo-custom-trigger">
            <a-layout-sider v-model="collapsed" :trigger="null" collapsible style="overflow-y:auto">
            <router-link to="/index"  class="logo" style="display:block">
              <img src="../../static/logo.jpg" alt="">
            </router-link>
            <a-menu
                :default-selected-keys="['1']"
                mode="inline"
                theme="light"
                :inline-collapsed="collapsed"
                @openChange="onOpenChange"
                :openKeys="openKeys"
                >
                <a-menu-item key="1" >
                  <router-link to="/index">
                    <a-icon type="home" />
                    <span>首页</span>
                  </router-link>
                </a-menu-item>
                <a-sub-menu  v-for="item in menu" :key="item.id">
                    <span slot="title"><a-icon :type="item.icon" /><span>{{item.title}}</span></span>
                    <a-menu-item :key="option.id" v-for="option in item.children">
                      <router-link :to="option.href" >
                        {{option.title}}
                      </router-link>
                    </a-menu-item>
                </a-sub-menu>
            </a-menu>
            </a-layout-sider>
            <a-layout>
            <a-layout-header style="background: #fff; padding: 0 20px 0 0;display:flex;justify-content: space-between;">
          
                <a-icon
                class="trigger"
                :type="collapsed ? 'menu-unfold' : 'menu-fold'"
                @click="() => (collapsed = !collapsed)"
                />

                <div style="display:flex;align-items: center;">
                  <div class="sipbtn" @click="opensip" v-if="pinfo.iskf==1">
                    <a-icon type="customer-service" theme="filled"/>
                    <span>SIP电话</span>
                  </div>

                  <a-dropdown overlayClassName="top-account-menu">
                    <a class="ant-dropdown-link" style="color:rgba(0,0,0,.65);">
                      <img src="../../static/head.png" class="mian-head" alt="">
                      {{pinfo.name}} <a-icon type="down" />
                    </a>
                    <div slot="overlay">
                      <div class="mian-user-head">
                          <img src="../../static/head.png" alt="">
                          <span>{{pinfo.name}}</span>
                          <router-link to="/person" >
                            个人中心<a-icon type="right" />
                          </router-link>
                      </div>
                      <a-menu>
                        <a-menu-item v-if="pinfo.item_title">{{pinfo.item_title}}</a-menu-item>
                        <a-menu-item v-else>--</a-menu-item>
                        <a-divider />
                        <a-menu-item @click="logout">退出登录</a-menu-item>
                      </a-menu>
                    </div>
                  </a-dropdown>
                </div>

            </a-layout-header>
            <a-layout-content
                :style="{  background: 'transparent', minHeight: '280px'}"
            >
                <router-view/>
            </a-layout-content>
            </a-layout>
        </a-layout>

        <!-- sip信息 -->
        <a-modal
        title="SIP信息"
        :visible="sipvisible"
        :footer="hide"
        :width="width"
        @cancel="handleCancel"
        >
          <a-descriptions :column="col">
            <a-descriptions-item label="IP/域名">
              {{pinfo.ccsipurl}}
            </a-descriptions-item>
            <a-descriptions-item label="坐席账号">
              {{pinfo.cc_id}}
            </a-descriptions-item>
            <a-descriptions-item label="坐席密码">
              {{pinfo.cc_password}}
            </a-descriptions-item>
            <a-descriptions-item label="使用说明">
              <a href="https://yh178.13524.net/explain/" target="_blanh">https://yh178.13524.net/explain/</a>
            </a-descriptions-item>
          </a-descriptions>
        </a-modal>
    </div>

</template>

<style>
#components-layout-demo-custom-trigger .trigger {
  font-size: 18px;
  line-height: 64px;
  padding: 0 24px;
  cursor: pointer;
  transition: color 0.3s;
}

#components-layout-demo-custom-trigger .trigger:hover {
  color: #1890ff;
}

#components-layout-demo-custom-trigger .logo {
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 16px;
}

section.ant-layout-has-sider{height: 100%;}
section.ant-layout-has-sider .ant-layout-sider-children{background: #fff;box-shadow: 2px 0 8px 0 rgb(29 35 41 / 5%);}
</style>


<script>
export default {
  data() {
    return {
      collapsed: false,
      menu:[],
      col:1,
      width:'380px',
      sipvisible:false,
      hide:false,
      pinfo:"",

      openKeys: [''],
    };
  },
  mounted(){
    this.fetch()
    this.personinfo()
    this.getdetail()
  },
  methods: {
    // 加密方式
    getdetail(){
        this.$axios.post('/api/system/systemsetpage',{

        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
                localStorage.setItem('pwdtype', res.data.data.passtype);
            }else{
                this.$message.warning(res.data.msg); 
            }
            
        })
    },
    onOpenChange(openKeys) {
      if (openKeys.length !== 0) {  
        this.openKeys = [openKeys[1]]
      } else {
        this.openKeys = ['']
      }
    },
    handleCancel(){
      this.sipvisible=false
    },
    // SIP信息
    opensip(){
      this.sipvisible=true
    },
    // 个人信息
    personinfo(){
       this.$axios.post('/api/system/adminpage',{
        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
              localStorage.setItem('aid', res.data.data.aid);
              this.pinfo=res.data.data
            }else{
              this.$message.warning(res.data.msg); 
            }
            
        })
    },
    fetch(){
      this.$axios.post('/api/system/mymenulist',{
        },{
            headers: {
                "token":localStorage.getItem('token'),
            }
        }).then((res)=>{
            if(res.data.code==200){
              this.menu=res.data.data
            }else if(res.data.code==2011){
              localStorage.setItem('token', '');
              this.$router.push({ path:'/login'})
            }else{
              this.$message.warning(res.data.msg); 
            }
            
        })
    },
    toggleCollapsed() {
      this.collapsed = !this.collapsed;
    },
    logout(){
      localStorage.setItem('token', '');
      this.$router.push({ path:'/login'})
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/home.vue